/**
 * Module dependencies.
 */

import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PieChartOutlined, SettingOutlined } from '@ant-design/icons';
import { Outlet } from 'react-router-dom';
import { Dashboard } from './dashboard';
import { appRoutes } from 'app/routes';
import { compileMenu } from 'app/core/utils/menu';
import { GrLanguage } from 'react-icons/gr';

/**
 * Export `SkinSettings` component.
 */

export function SkinSettings(): JSX.Element {
  const [translate] = useTranslation();
  const items = useMemo(
    () =>
      compileMenu([
        {
          key: '1',
          pathname: appRoutes.dashboard.settings.base,
          icon: <PieChartOutlined />,
          label: translate('settings.menu.overview')
        },
        {
          key: '2',
          pathname: appRoutes.dashboard.settings.profile,
          icon: <PieChartOutlined />,
          label: translate('settings.menu.profile')
        },
        {
          key: '3',
          pathname: appRoutes.dashboard.settings.languages,
          icon: <GrLanguage />,
          label: translate('settings.menu.languages')
        },
        {
          key: '4',
          pathname: appRoutes.dashboard.settings.config,
          icon: <SettingOutlined />,
          label: translate('settings.menu.config')
        }
      ]),
    [translate]
  );

  return (
    <Dashboard menu={items}>
      <Outlet />
    </Dashboard>
  );
}
